import { CSSResultGroup, LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import componentStyles from './ghs-mychart-options-menu.css.lit';

@customElement('mychart-options-menu')
export class MyChartOptionsMenu extends LitElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String }) bellinUrl = '';
  @property({ type: String }) bellinButtonText = '';
  @property({ type: String }) bellinParagraph = '';
  @property({ type: String }) emplifyUrl = '';
  @property({ type: String }) emplifyButtonText = '';
  @property({ type: String }) emplifyParagraph = '';
  @property({ type: String }) extraLinkUrl = '';
  @property({ type: String }) extraLink = '';

  private renderSection(
    url: string,
    text: string,
    paragraph: string,
    variant: string
  ) {
    return html`
      <ghs-button
        site="BH"
        url=${url}
        icon="chevron-right"
        variant=${variant}
        container-fit-variant=""
        button-target="_blank"
      >
        ${text}
      </ghs-button>
      <div class="info-text">${unsafeHTML(paragraph)}</div>
    `;
  }

  render() {
    return html`
      <div class="light-blue">
        <div class="section">
          ${this.renderSection(
            this.bellinUrl,
            this.bellinButtonText,
            this.bellinParagraph,
            'primary'
          )}
        </div>
      </div>
      <div class="mint-to-be">
        <div class="section">
          ${this.renderSection(
            this.emplifyUrl,
            this.emplifyButtonText,
            this.emplifyParagraph,
            'emplifynew'
          )}
          <ghs-button
            class="link"
            url=${this.extraLinkUrl}
            variant="emplifymychart"
            icon="chevron-right"
            container-fit-variant=""
          >
            ${this.extraLink}
          </ghs-button>
        </div>
      </div>
    `;
  }
}
